var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockedPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1792_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 6.66667H12.7778C14.3125 6.66667 15.5556 7.90972 15.5556 9.44444V15C15.5556 16.5347 14.3125 17.7778 12.7778 17.7778H2.77778C1.24375 17.7778 0 16.5347 0 15V9.44444C0 7.90972 1.24375 6.66667 2.77778 6.66667H11.1111V4.44444C11.1111 1.98993 13.1007 0 15.5556 0C18.0104 0 20 1.98993 20 4.44444V7.22222C20 7.52778 19.75 7.77778 19.4444 7.77778C19.1389 7.77778 18.8889 7.52778 18.8889 7.22222V4.44444C18.8889 2.60347 17.3958 1.11111 15.5556 1.11111C13.684 1.11111 12.2222 2.60347 12.2222 4.44444V6.66667ZM2.77778 7.77778C1.85729 7.77778 1.11111 8.52431 1.11111 9.44444V15C1.11111 15.9201 1.85729 16.6667 2.77778 16.6667H12.7778C13.6979 16.6667 14.4444 15.9201 14.4444 15V9.44444C14.4444 8.52431 13.6979 7.77778 12.7778 7.77778H2.77778Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1792_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7778,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockedPadlock);
export default __webpack_public_path__ + "static/media/unlocked_padlock.f223b563aa0cdeec68bd4b4a4a3b03e5.svg";
export { ForwardRef as ReactComponent };